import React, { useState, useEffect } from "react";
import {
  Card,
  Heading,
  Paragraph,
  Button,
  Table,
} from "ProtoType/Slack/styles/Common";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SG_GET_SLACK_EVENT,
  SG_ADD_SLACK_EVENT,
  SG_DELETE_SLACK_EVENT,
  CLEAR_SLACK_EVENT_UPDATES,
} from "constants/actions";

const SlackEvents = ({ get_slack_scheduler }) => {
  const dispatch = useDispatch();
  const [groupMembers, setGroupMembers] = useState([]);
  const [slackEvents, setSlackEvents] = useState([]);

  const { get_slack_event } = useSelector(
    (state) => ({
      get_errors: state.errors,
      get_slack_event: state.slack_event,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (get_slack_scheduler?.id) {
      dispatch({
        type: SG_GET_SLACK_EVENT,
        payload: `slack_scheduler_id=${get_slack_scheduler?.id}`,
      });
    }
  }, [dispatch, get_slack_scheduler]);

  useEffect(() => {
    setGroupMembers(
      get_slack_scheduler?.organization_group_details
        ?.organization_group_members
    );
  }, [get_slack_scheduler]);

  useEffect(() => {
    if (get_slack_event) {
      setSlackEvents(get_slack_event?.slack_events);
    }
  }, [get_slack_event]);

  useEffect(() => {
    if (get_slack_event?.updated) {
      
      const timeoutId = setTimeout(() => {
        dispatch({ type: CLEAR_SLACK_EVENT_UPDATES });
        dispatch({
          type: SG_GET_SLACK_EVENT,
          payload: `slack_scheduler_id=${get_slack_scheduler?.id}&page=1`,
        });
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [get_slack_event, get_slack_scheduler, dispatch]);

console.log("get_slack_event", get_slack_event);

  function AddNewEvent() {
    dispatch({
      type: SG_ADD_SLACK_EVENT,
      payload: {
        slack_scheduler: get_slack_scheduler?.id,
      },
    });
  }

  function DeleteEvent(id) {
    dispatch({
      type: SG_DELETE_SLACK_EVENT,
      payload: {
        id: id,
      },
    });
  }

  return (
    <Card>
      <Heading>
        Slack Events [The Slack Events are Trigger only for Enrolled Employees]
      </Heading>
      <Paragraph>
        Next Event Scheduled at {get_slack_scheduler?.next_run_datetime}{" "}
      </Paragraph>
      <Button
        background={(props) => props.theme.colors.primary}
        onClick={AddNewEvent}
      >
        Add New Event
      </Button>
      <Paragraph>The new event is triggered automatically on the scheduled time on date just for testing should NOT go into production.</Paragraph>
      <Table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Status</th>
            <th>Total Employees</th>
            <th>Pending</th>
            <th>Completed</th>
            <th>Failed</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {slackEvents?.results &&
            slackEvents?.results.map((event) => (
              <tr key={event.id}>
                <td>{event.id}</td>
                <td>{event.status}#{event?.status_text}</td>
                <td>{event.employee_status?.summary?.total}</td>
                <td>{event.employee_status?.summary?.pending}</td>
                <td>{event.employee_status?.summary?.completed}</td>
                <td>{event.employee_status?.summary?.failed}</td>
                <td>
                  {event.status === 1 ? <Button
                    background={(props) => props.theme.colors.danger}
                    onClick={() => DeleteEvent(event.id)}
                  >
                    Delete Event
                  </Button> : null}
                  
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </Card>
  );
};

export default SlackEvents;
